<template>
  <div />
</template>

<!--/////////////////////////////////////////////////////////////////////////-->

<script>
export default {
  name: 'slideshow-audio',
  props: {
    videos: Array
  }
}
</script>
